export class BrandsQuery {
  constructor () {
    this.current = undefined;
    this.pageSize = undefined;
    this.brand = undefined;
    this.department = undefined;
  }

  static get KEYS () {
    return {
      BRAND: 'brand',
      DEPARTMENT: 'department'
    };
  }
}
